/**
 * Bravo Assistant UI state plus one-shot launch commands. Launches are
 * deliberately memory-only: a Wrkthru It command must never replay after reload.
 */
import { create } from 'zustand';
import type { WrkthruItSeed } from 'shared/src/wrkthru/wrkthru-it-seed';

export type PendingAssistantSend = {
  id: string;
  status: 'send';
  conversationId: string;
  seed: WrkthruItSeed;
};

export type AssistantLaunch =
  | { id: string; status: 'resolving' }
  | { id: string; status: 'select'; conversationId: string }
  | PendingAssistantSend;

type AssistantStore = {
  isOpen: boolean;
  hasOpened: boolean;
  launch: AssistantLaunch | null;
  openPanel: () => void;
  closePanel: () => void;
  startLaunch: (id: string) => void;
  finishLaunch: (launch: AssistantLaunch) => void;
  clearLaunch: (id: string) => void;
};

export const useAssistantStore = create<AssistantStore>(set => ({
  isOpen: false,
  hasOpened: false,
  launch: null,
  openPanel: () => set({ isOpen: true, hasOpened: true }),
  closePanel: () => set({ isOpen: false }),
  startLaunch: id => set({ isOpen: true, hasOpened: true, launch: { id, status: 'resolving' } }),
  finishLaunch: launch => set(state => (state.launch?.id === launch.id ? { launch } : state)),
  clearLaunch: id => set(state => (state.launch?.id === id ? { launch: null } : state))
}));
